import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import statusesMixin from './statusesMixin'
import vacancyPartiesMixin from './vacancyPartiesMixin'
import snackMixin from '@/mixins/snackMixin'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [snackMixin, statusesMixin, vacancyPartiesMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.vacancyChat.application.value,
      archiving: (state: RootState) => state.vacancyChat.archiving,
    }),
    isMetaArchived() {
      return this.application.meta?.archived
    },
    hasRemoveFromArchive() {
      return !this.isTemporary && this.isEmployer && !this.isDone && this.isMetaArchived
    },
  },
  methods: {
    ...mapActions({
      updateArchiveApplicationFlag: 'vacancyChat/updateArchiveApplicationFlag',
    }),
    async setArchivedMeta(flag: boolean) {
      try {
        await this.updateArchiveApplicationFlag({ applicationId: this.application.id, flag })
      } catch (err) {
        console.error(err)
        this.openSnackbar({
          type: this.SnackTypes.FAILURE,
          text: 'Error sending request. Please try again.',
        })
      }
    },
  },
})
